import { useController, useFormContext } from 'react-hook-form';
import { TextField } from '@mui/material';
import { memo } from 'react';

interface Props {
  name: string;
  label: string;
  size?: 'small' | 'medium';
  [key: string]: any;
}

const RHFTextField = memo(({ name, label, size = 'small', ...rest }: Props) => {
  const { control } = useFormContext();
  console.log('test');

  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <TextField
      {...field}
      label={label}
      required
      fullWidth
      size={size}
      error={!!error}
      helperText={error?.message}
      sx={{
        '& .MuiInputLabel-asterisk': {
          color: 'red !important',
        },
      }}
      {...rest}
    />
  );
});

export default RHFTextField;
